import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import PaginationComponent from "../../components/common/PaginationModal";
import CalendarFilter from "../../components/common/CalenderFilter";
import SuccessModal from "../../components/common/SuccessModal";
import ConfirmationModal from "../../components/common/ConfirmationModal";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import {
      ChangeLeaveStatus,
      DeleteLeave,
      GetLeaveList,
} from "../../services/LeaveManagement/LeaveManage";
import ErrorModal from "../../components/common/ErrorModel";
import Select from "react-select";
import NoResultFoundModel from "../../components/common/NoDataFound";
import AttendanceAddUpdateModal from "./AttendanceAddUpdateModal";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { globalSelectStyles } from "../../middleware/enum";
import Utils from "../../middleware/Utils";
const AttendanceList = () => {
      const navigate = useNavigate();
      const [openLeavePopUpModelOpen, setOpenLeavePopupModel] = useState(false);
      const [fromDate, setFromDate] = useState(null);
      const [toDate, setToDate] = useState(null);
      const [errorMessage, setErrorMessage] = useState(false);
      const [isErrorOpen, setIsErrorOpen] = useState(false);
      const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
      const [OpenRemarkModel, setOpenViewRemark] = useState(false);
      const [confirmationModal, setConfirmationModal] = useState(false);
      const [modelAction, setModelAction] = useState("");
      const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
      const [modelRequestData, setModelRequestData] = useState({
            KeyID: null,
            Action: null,
            status: null,
            Name: null,
            remark: null,
      });
      //List Params
      const [LeaveSearch, setLeaveSearch] = useState("");
      const [LeaveList, setLeaveList] = useState([]);
      const [LeaveListCount, setLeaveListCount] = useState(-1);
      const [LeaveCurrentPage, setLeaveCurrentPage] = useState(1);
      //Context
      const { setLoader } = useContext(LoaderContext);
      const { authDetails, pageSize, PanalModuleName, defaultAccess } =
            useContext(AuthContext); //Tab Change Function  //initial UseEffect
      const [clientObj, setClientObj] = useState({})
      //======================useEffect =======================
      useEffect(() => {
            GetLeaveListData(1, "Leave", null);
      }, []);

      useEffect(() => {
            if (isAddUpdateDone) {
                  setLeaveSearch("");
                  GetLeaveListData(LeaveCurrentPage, "Leave", null);

                  setIsAddUpdateDone(false);
            }
      }, [isAddUpdateDone]);
      //Leave Role List Api
      const GetLeaveListData = async (i, tab, searchKeyword) => {
            const pageNoList = i - 1;
            try {
                  setLoader(true);
                  let response = await GetLeaveList({
                        moduleName: "Leave",
                        pageSize: pageSize,
                        pageNo: pageNoList,
                        searchKeyword:
                              searchKeyword === undefined ? LeaveSearch : searchKeyword,
                        userKeyID: authDetails.userKeyID,
                        moduleName: tab,
                  });
                  if (response.statusCode === 200) {
                        setLoader(false);
                        const list = response.responseData?.data;
                        setLeaveListCount(response.totalCount);
                        setLeaveList(list);
                  } else {
                        setLoader(false);
                  }
            } catch (error) {
                  setLoader(false);
                  console.log(error);
            }
      };

      //Confirmation Button Click
      const handleConfirmBtn = async () => {
            setLoader(true);
            if (modelAction === "Delete") {
                  let data = await DeleteLeave(
                        PanalModuleName,
                        modelRequestData.KeyID,
                        authDetails.userKeyID
                  );
                  try {
                        if (data?.statusCode === 200) {
                              setLoader(false);
                              setIsAddUpdateDone(true);
                              setConfirmationModal(false);
                              setShowSuccessPopupModal(true);
                        } else {
                              setLoader(false);
                              setConfirmationModal(false);
                              setIsErrorOpen(true);
                              const errorMessage = data?.response?.data?.errorMessage;
                              setErrorMessage(errorMessage);
                        }
                  } catch (error) {
                        setLoader(false);
                  }
            } else if (modelAction === "Status") {
                  try {
                        let data = await ChangeLeaveStatus(
                              PanalModuleName,
                              modelRequestData.KeyID,
                              authDetails.userKeyID
                        );
                        if (data?.statusCode === 200) {
                              setLoader(false);
                              setIsAddUpdateDone(true);
                              setConfirmationModal(false);
                              setShowSuccessPopupModal(true);
                        } else {
                              setLoader(false);
                              setIsErrorOpen(true);
                              setConfirmationModal(false);
                              const errorMessage = data?.response?.data?.errorMessage;
                              setErrorMessage(errorMessage);
                        }
                  } catch (error) {
                        setLoader(false);
                  }
            }
      };
      //Change Page Button
      const HandlePageChange = async (pageNumber) => {
            setLeaveCurrentPage(pageNumber);
            await GetLeaveListData(pageNumber, "Active"); // Call your function with the selected page number
      };

      // const handleSearchFunction = (searchValue) => {
      //   setLeaveSearch(searchValue);
      //   GetLeaveListData(1, "Active", searchValue);
      // };

      const handleSearchFunction = (searchValue) => {
            setLeaveSearch(searchValue);
            if (searchValue?.trim() === "") {
                  // If the search input is empty, fetch the full list again
                  setLeaveCurrentPage(1); // Reset to the first page
                  GetLeaveListData(1, "Leave", null); // Ensure to pass the correct tab
            } else {
                  // If there is a search value, fetch the filtered list
                  GetLeaveListData(1, "Leave", searchValue); // Ensure to pass the correct tab
            }
      };

      const attendanceBtnClick = () => {
            setOpenLeavePopupModel(true)
      }

      return (
            <>
                  <div className="space-y-6 mx-auto rep-width mx-auto px-4">
                        <div className="h-full bg-white shadow rounded-lg flex flex-col">
                              {/* Header Section */}
                              <div
                                    style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "4px 15px",
                                    }}
                                    className="border-b p-4 overflow-x-auto"
                              >
                                    <div className="flex space-x-4">
                                          <button
                                                className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                                          >
                                                Attendance
                                          </button>
                                    </div>
                              </div>
                              <div className="p-2 border-b flex flex-wrap sm:flex-nowrap items-center justify-between gap-3">
                                    {/* Left Side: Select Dropdown */}
                                    <Select
                                          className="w-[420px]"
                                          value={Utils.ClientType?.find(
                                                (item) => item.value === clientObj.businessTypeID
                                          )}
                                          onChange={(e) =>
                                                setClientObj({
                                                      ...clientObj,
                                                      businessTypeID: e.value,
                                                })
                                          }
                                          options={Utils.ClientType || ""}
                                          styles={globalSelectStyles}
                                    />

                                    <CalendarFilter
                                          onDateChange={() => { }}
                                          toDate={toDate}
                                          setToDate={setToDate}
                                          fromDate={fromDate}
                                          setFromDate={setFromDate}
                                    />

                                    {/* Right Side: Search Bar & Add Button */}
                                    <div className="flex flex-wrap sm:flex-nowrap items-center w-full sm:w-auto gap-3">
                                          {/* Search Bar */}
                                          <div className="relative flex items-center w-full sm:w-64">
                                                <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                                                <input
                                                      type="text"
                                                      className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                                                      placeholder="Search Attendance"
                                                      value={LeaveSearch}
                                                      onChange={(e) => {
                                                            handleSearchFunction(e.target.value, PanalModuleName);
                                                      }}
                                                />
                                          </div>

                                          {/* Add Button */}
                                          <Tooltip title="Add Daily Diary Sheet">
                                                <button
                                                      id="addBtn"
                                                      type="button"
                                                      onClick={() => {

                                                            attendanceBtnClick();
                                                      }}
                                                      className="bg-gradient-to-r text-nowrap from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white px-5 py-2 rounded-lg text-12 font-medium shadow-md shadow-cyan-500/30 hover:shadow-cyan-400/40 transition-all duration-300"
                                                >
                                                      Attendance
                                                </button>
                                          </Tooltip>



                                    </div>
                              </div>

                              {/* Tab Content */}
                              {/* <div className="p-4"> */}
                              <div className="flex flex-col table_wrapper border border-gray-200">
                                    <div className="flex-1 overflow-y-auto  ">
                                          <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                                                <thead>
                                                      <tr className="z-1 sticky top-0 bg-white">
                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Employee Name
                                                            </th>
                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Date
                                                            </th>
                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Role
                                                            </th>
                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Location
                                                            </th>
                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Check-in Time
                                                            </th>
                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Check-out Time
                                                            </th>
                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Status
                                                            </th>

                                                            <th className="text-12  border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Action
                                                            </th>
                                                      </tr>
                                                </thead>
                                                <tbody>
                                                      {LeaveList.map((leave, index) => (
                                                            <tr
                                                                  key={index}
                                                                  className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                                            >
                                                                  <td
                                                                        style={{ color: "#0000EE" }}
                                                                        onClick={() => {
                                                                              setModelRequestData({
                                                                                    ...modelRequestData,
                                                                                    remark: leave.remark,
                                                                              });
                                                                              setOpenViewRemark(true);
                                                                        }}
                                                                        className="whitespace-nowrap text-center p-1"
                                                                  >
                                                                        Rohit Bharit
                                                                  </td>
                                                                  <td className="whitespace-nowrap text-center p-1">
                                                                        {new Date(leave.fromDate).toLocaleDateString("en-GB")}
                                                                  </td>
                                                                  <td className="whitespace-nowrap text-center p-1">

                                                                        {leave.isFullDay ? "Full Day" : "Half Day"}
                                                                  </td>
                                                                  <td className="whitespace-nowrap text-center p-1">
                                                                        {new Date(leave.fromDate).toLocaleDateString("en-GB")}
                                                                  </td>
                                                                  <td className="whitespace-nowrap text-center p-1">
                                                                        {leave.fromDate}
                                                                  </td>
                                                                  <td className="whitespace-nowrap text-center p-1">
                                                                        {leave.toDate}                                                                        {/* {new Date(leave.toDate).toLocaleDateString("en-GB")}check out */}
                                                                  </td>
                                                                  <td className="whitespace-nowrap text-center p-1">
                                                                        {leave.remark}
                                                                  </td>
                                                                  <td className="whitespace-nowrap text-center p-1">
                                                                        <div className="flex justify-center gap-2">
                                                                              {/* Add Leave Button */}
                                                                              {defaultAccess.LeaveCanUpdate && (
                                                                                    <Tooltip title="Update Attendance , Requested Admin, but this is admin panel ">
                                                                                          <button
                                                                                                // onClick={() => {
                                                                                                //       setModelRequestData({
                                                                                                //             KeyID: leave.leaveKeyId,
                                                                                                //             Action: "Update",
                                                                                                //       });
                                                                                                //       setOpenLeavePopupModel(true);
                                                                                                // }}
                                                                                                className="text-[#135EA0] hover:text-[#135EA0]"
                                                                                          >
                                                                                                <FaEdit className="text-12" />
                                                                                          </button>
                                                                                    </Tooltip>
                                                                              )}


                                                                        </div>
                                                                  </td>
                                                            </tr>
                                                      ))}
                                                </tbody>
                                          </table>
                                          {LeaveListCount <= 0 && (
                                                <NoResultFoundModel totalRecords={LeaveListCount} />
                                          )}
                                    </div>
                              </div>
                              {LeaveListCount > pageSize && (
                                    <div className="flex justify-end ">
                                          <PaginationComponent
                                                totalPages={Math.ceil(LeaveListCount / pageSize)}
                                                currentPage={LeaveCurrentPage}
                                                onPageChange={HandlePageChange}
                                          />
                                    </div>
                              )}
                              {openLeavePopUpModelOpen && (
                                    <AttendanceAddUpdateModal
                                          setIsAddUpdateDone={setIsAddUpdateDone}
                                          modelRequestData={modelRequestData}
                                          onClose={() => setOpenLeavePopupModel(false)}
                                    />
                              )}


                              <ConfirmationModal
                                    show={confirmationModal}
                                    onHide={() => setConfirmationModal(false)}
                                    actionType={modelAction}
                                    onConfirm={handleConfirmBtn}
                                    modelRequestData={modelRequestData}
                              />

                              <SuccessModal
                                    isOpen={showSuccessPopupModal}
                                    onClose={() => setShowSuccessPopupModal(false)}
                                    modelAction={modelAction}
                                    actionMessage={
                                          modelAction === "Status"
                                                ? "Status has been changed successfully!"
                                                : modelRequestData.Name
                                    }
                              />
                              <ErrorModal
                                    isOpen={isErrorOpen}
                                    onClose={() => setIsErrorOpen(false)}
                                    errorMessage={errorMessage}
                              />
                        </div>
                  </div>
            </>
      );
};

export default AttendanceList;
